import React, { useState } from "react";
import { Modal, DatePicker, Row, Form, Spin } from "antd";
import { RootStateOrAny, useSelector } from "react-redux";
import moment from "moment";
import { useAccountDetalizationContainerContext } from "../../containers/AccountDetalizationContainer/AccountDetalizationContainerContext";
import {
  displayFormat,
  toHttpFormatEndOfDay,
  toHttpFormatStartOfDay,
} from "../../lib/utils/formatDate";

const { RangePicker } = DatePicker;

interface IProps {
  isReprocessModalVisible: boolean;
  setIsReprocessModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  firstVersionFromDate?: string;
}

const ReprocessModal = (props: IProps) => {
  const { isReprocessModalVisible, setIsReprocessModalVisible, firstVersionFromDate } = props;
  const { account } = useSelector((state: RootStateOrAny) => state.accounts);
  const [dates, setDates] = useState<moment.Moment[]>();
  const context = useAccountDetalizationContainerContext();
  const [form] = Form.useForm();

  function onChange(range) {
    setDates(range);
  }

  const handleOk = () => {
    form.validateFields().then(() => {
      if (dates && context) {
        context.runReprocess({
          fromDate: toHttpFormatStartOfDay(dates[0]),
          toDate: toHttpFormatEndOfDay(dates[1]),
          subscribers: account.subscribers.map((item) => String(item.externalId)),
        });
        setIsReprocessModalVisible(false);
        form.resetFields();
      }
    });
  };

  const handleCancel = () => {
    form.resetFields();
    setIsReprocessModalVisible(false);
  };

  return (
    <>
      <Modal
        title="Перетарификация"
        visible={isReprocessModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Spin spinning={!firstVersionFromDate}>
          {firstVersionFromDate && (
            <Row justify="center">
              <Form form={form}>
                <Form.Item
                  name="dates"
                  rules={[
                    {
                      required: true,
                      message: "",
                    },
                  ]}
                >
                  <RangePicker
                    onChange={onChange}
                    disabledDate={(date) =>
                      date.isBefore(firstVersionFromDate, "day") || date.isAfter(moment(), "day")
                    }
                    format={displayFormat}
                  />
                </Form.Item>
              </Form>
            </Row>
          )}
        </Spin>
      </Modal>
    </>
  );
};

export default ReprocessModal;
